module.exports = __webpack_public_path__ + "static/img/14000550.354de6e0.png";